"use client";

import { YEARLYSchedule } from "@/constants/constant-client";
import { ALLYearTuple } from "@/constants/type";
import { useParams, useSearchParams } from "next/navigation";
import { Suspense } from "react";
import { SelectSetSearchParam } from "./select-set";

function Filter({ paramName }: { paramName: string }) {
  const { year } = useParams<{ year: ALLYearTuple }>();
  const toYYYYMMDD = (d: string) => new Date(d).toISOString().split("T")[0].replaceAll("-", "");
  const Y = YEARLYSchedule?.[year] ?? YEARLYSchedule["2025"];

  const options = [
    { val: `${toYYYYMMDD(Y.Apr.start)}${toYYYYMMDD(Y.Apr.end)}9`, name: "3/4月" },
    { val: `${toYYYYMMDD(Y.May.start)}${toYYYYMMDD(Y.May.end)}9`, name: "5月" },
    {
      val: `${toYYYYMMDD(Y.interLeague.start)}${toYYYYMMDD(Y.interLeague.end)}9`,
      name: "交流戦",
    },
    { val: `${toYYYYMMDD(Y.Jun.start)}${toYYYYMMDD(Y.Jun.end)}9`, name: "6月" },
    { val: `${toYYYYMMDD(Y.Jul.start)}${toYYYYMMDD(Y.Jul.end)}9`, name: "7月" },
    { val: `${toYYYYMMDD(Y.Aug.start)}${toYYYYMMDD(Y.Aug.end)}9`, name: "8月" },
    { val: `${toYYYYMMDD(Y.Sep.start)}${toYYYYMMDD(Y.Sep.end)}9`, name: "9/10月" },
  ];
  const searchParams = useSearchParams();
  const game = searchParams.get(paramName);
  const start = `${game?.substring(0, 4)}-${game?.substring(4, 6)}-${game?.substring(6, 8)}`;
  const end = `${game?.substring(8, 12)}-${game?.substring(12, 14)}-${game?.substring(14, 16)}`;
  const diff = new Date(end).getTime() - new Date(start).getTime();

  if (diff < 864000000)
    return (
      <select className="select select-sm w-full max-w-xs" aria-label={paramName} disabled>
        <option>月指定</option>
      </select>
    );

  return (
    <SelectSetSearchParam paramName={paramName}>
      <option value={paramName} disabled>
        月指定
      </option>
      {options.map((m) => (
        <option key={m.name} value={m.val}>
          {m.name}
        </option>
      ))}
    </SelectSetSearchParam>
  );
}
export function MonthFilter({ paramName }: { paramName: string }) {
  return (
    <Suspense
      fallback={
        <select className={"select select-sm w-full max-w-xs"}>
          <option value={paramName} disabled>
            月指定
          </option>
        </select>
      }
    >
      <Filter paramName={paramName} />
    </Suspense>
  );
}
